module.exports = __webpack_public_path__ + "img/service3-1.50664610.jpg";